import { render } from "./ProductVideoCreateComponent.vue?vue&type=template&id=77285161"
import script from "./ProductVideoCreateComponent.vue?vue&type=script&lang=js"
export * from "./ProductVideoCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/video/ProductVideoCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77285161"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77285161', __exports__)) {
    api.reload('77285161', __exports__)
  }
  
  module.hot.accept("./ProductVideoCreateComponent.vue?vue&type=template&id=77285161", () => {
    api.rerender('77285161', render)
  })

}


export default __exports__